import React from "react";
import PropTypes from "prop-types";

const UserStatistics = ({visited_games_count, organized_games_count, missed_games_count}) => {
    return <div className="stat">
        <h4 className="stat__title">Статистика</h4>

        <ul className="stat__items">
            <li className="bg-primary-default">
                <p className="stat__digit">
                    {visited_games_count +
                        missed_games_count}
                </p>
                <p className="fs-caption">Всего</p>
            </li>

            <li>
                <p className="stat__digit">
                    {organized_games_count}
                </p>
                <p className="fs-caption">Организовано</p>
            </li>

            <li>
                <p className="stat__digit">
                    {missed_games_count}
                </p>
                <p className="fs-caption">Пропущено</p>
            </li>
        </ul>
    </div>
}

UserStatistics.propTypes = {
    visited_games_count: PropTypes.number,
    organized_games_count: PropTypes.number,
    missed_games_count: PropTypes.number,
}

export default UserStatistics
